<template>
  <div v-if="renderComponent">
    <div>
      <h5 class="vue-title pull-left custom-header">
        <strong>{{ $t("PARTNERLIST") }}</strong>
      </h5>
      <p
        class="float-right btn-add-partner"
        v-if="checkPermisssion('PARTNER', 'PARTNER_LIST')"
      >
        {{ $t("ADD") }}
        <a href="#/createpartner">
          <em class="fas fa-plus-circle"></em>
        </a>
      </p>
      <b-input-group class="pull-right search-text-box">
        <template v-slot:prepend>
          <b-input-group-text @click="onSerach">
            <em class="fa fa-search"></em>
          </b-input-group-text>
        </template>
        <b-form-input
          size="sm"
          @keyup.enter="onSerach"
          autocomplete="off"
          v-model="searchKeyword"
        ></b-form-input>
      </b-input-group>
    </div>
    <c-table
      :table-data="partnerTableList.list"
      :fields="tableHeader"
      :per-page="10"
      striped
      hover
      :total="partnerTableList.pageTotal"
      :update="showStatusChangeModal"
      :edit="editPartnerItem"
      :delete="showDeleteModal"
      :dbClick="dbClick"
      :user="userData"
      :sortTable="sortTable"
      :isBusy="isBusy"
      :pagination="pagination"
      :countPerPage="currentPage"
    >
    </c-table>
    <nav>
      <div class="pagination-module">
        <b-pagination
          :total-rows="partnerTableList.pageTotal"
          @change="pagination"
          :per-page="10"
          v-model="currentPage"
          :prev-text="$t('FORWARD')"
          :next-text="$t('NEXT')"
        />
      </div>
    </nav>
    <b-modal id="modal-delete" hide-footer>
      <template v-slot:modal-title>
        {{ $t("DELETECONFIRMATION") }}
      </template>
      <p class="my-2 wrapText">
        {{ selectedItemForDelete.name }} {{ $t("DELETECONFIRMATIONCOMMOM") }}
      </p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-danger"
            class="buttons-align-right"
            size="sm"
            @click="deleteSelectedRow()"
            >{{ $t("DELETE") }}</b-button
          >

          <b-button
            variant="outline-secondary"
            size="sm"
            class="buttons-align-right"
            @click="$bvModal.hide('modal-delete')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-Status" hide-footer @hidden="close">
      <template v-slot:modal-title>
        {{ $t("STATUSCHANGECONFIRMATION") }}
      </template>
      <p>{{ $t("CHANGESTATUSCONFIRMATION") }}</p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="buttons-align-right"
            @click="ChangeStatus()"
            >{{ $t("SUBMIT") }}</b-button
          >

          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="close()"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  PARTNER_SERVICE_LIST,
  DELETE_PARTNER,
  UPDATE_SERVICE_PARTNER
} from "@/store/actions.type";
import cTable from "@/components/Table.vue";
import { checkPermisssion } from "@/shared/utils.js";

export default {
  name: "partner-list",
  data() {
    return {
      searchKeyword: "",
      currentPage: 1,
      renderComponent: true,
      checkPermisssion: checkPermisssion,
      tableHeader: [],
      selectedItemForDelete: {},
      sortField: "",
      sortDirection: false,
      isBusy: true
    };
  },
  computed: {
    ...mapGetters(["partnerTableList"])
  },
  components: {
    cTable
  },
  methods: {
    /**
     * View Detials of the  table row
     * Input @param {Number} userId Seleted Row id to View
     * Output  @param {Number} userId  append to routing Params then Redirect to Details page
     */
    dbClick: function(record, index) {
      this.$router.push({
        name: "detailPartner",
        params: {
          id: record.id
        }
      });
    },
    /**
     * Show Delete Modal
     * Input @param {object} row Seleted Row to Delete
     * Output PopUp the Delete Modal
     */
    showDeleteModal: function(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-delete");
    },

    /**
     * Sort function on  table
     * Input 1.@param {String} sortField name of the Field , 2.@param {String} sortDirection Direction of the Sort(Ascending or Descending)
     * Output @param {List}   response.list  Filtered List
     */
    async sortTable(field, direction) {
      this.isBusy = true;
      this.sortField = field;
      this.sortDirection = direction;
      this.loadTableData(this.currentPage);
    },

    /**
     * Edit the table row
     * Input @param {Number} userId Seleted Row id to Edit
     * Output  @param {Number} userId  append to routing Params then Redirect to edit page
     */
    editPartnerItem(row) {
      /* Redirect to edit page */
      if (_.get(row, "id", 0)) {
        this.$router.push({
          name: "editServicepartner",
          params: {
            id: row.id
          }
        });
      }
    },

    /**
     * Delete function for table Row
     * Input @param {Number} userID selected Row ID
     * Output @param {String}   data.status  Boolean status Api call
     */
    async deleteSelectedRow() {
      this.$bvModal.hide("modal-delete");

      this.isLoading = this.$loading.show({
        loader: "dots",
        color: "#007bff"
      });

      let data = await this.$store.dispatch(DELETE_PARTNER, {
        id: this.selectedItemForDelete.id
      });
      this.isLoading.hide();

      if (data) {
        if (data.status) {
          this.$toast.success({
            message: data.message
          });
          this.isBusy = true;
          if (this.partnerTableList.list.length === 1) {
            /* Data is last row. need to redirect to first page other wise current page*/
            this.loadTableData(1);
          } else {
            await this.$store.dispatch(PARTNER_SERVICE_LIST, {
              search_query: this.searchKeyword,
              field: this.sortField,
              sort: this.sortDirection,
              page: this.currentPage
            });
            this.isBusy = false;
          }
        }
      } else {
        this.$toast.error({
          message: data.message
        });
      }
    },
    /**
     * Status function for table Row
     * Input 1,@param {Number} userID  selected Row ID 2,@param {string} status  (Active or Inactive)
     * Output @param {boolean}   data.status  status of the api call (true or false)
     */
    async ChangeStatus() {
      this.isLoading = this.$loading.show({
        loader: "dots",
        color: "#007bff"
      });
      let selectedItemId = _.get(this.selectedItemForDelete, "id", 0);
      this.$bvModal.hide("modal-Status");

      if (selectedItemId) {
        let status = _.get(this.selectedItemForDelete, "status", "");
        let data = await this.$store.dispatch(UPDATE_SERVICE_PARTNER, {
          id: selectedItemId,
          status: status == "active" ? "inactive" : "active"
        });
        this.isLoading.hide();
        if (_.get(data, "status", "")) {
          this.$toast.success({
            message: _.get(data, "message", "")
          });

          this.isBusy = true;
          await this.$store.dispatch(PARTNER_SERVICE_LIST, {
            search_query: this.searchKeyword,
            field: this.sortField,
            sort: this.sortDirection,
            page: this.currentPage
          });
          this.isBusy = false;
        } else {
          this.$toast.error({
            message: data.message
          });
        }
      } else {
        this.$bvModal.hide("modal-Status");
        this.isLoading.hide();
      }
    },
    /*Compomonet Rerendering */
    close() {
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    /**
     * Show Status Change Modal
     * Input @param {object} row Seleted Row to Change status of it
     * Output PopUp the Status Change Modal
     */
    showStatusChangeModal(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-Status");
    },

    /* Pagintaion */
    pagination(page) {
      this.loadTableData(page);
    },
    /* Loading table.
      Param: page number.
      Details: it will call api with search key, sort field, direction and current page
       */
    async loadTableData(page) {
      this.currentPage = page;
      this.isBusy = true;
      await this.$store.dispatch(PARTNER_SERVICE_LIST, {
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage
      });
      this.isBusy = false;
    },

    /**
     * onSearch function on  table
     * Input @param {String} search_query Search keyword
     * Output @param {List}   response.list  Filtered List
     */
    onSerach() {
      /* Passing 1 as page number. After load paginiton should be in frst page*/
      this.loadTableData(1);
    }
  },
  async created() {
    this.isBusy = true;
    this.$store
      .dispatch(PARTNER_SERVICE_LIST, {
        field: "id",
        sort: "desc"
      })
      .then(() => {
        this.isBusy = false;
      });

    this.tableHeader = [
      {
        key: "user.userid",
        label: this.$t("ID"),
        class: "text-left",
        sortable: true
      },
      {
        key: "name",
        label: "提携先名",
        sortable: true,
        class: "text-left"
      },
      {
        key: "custom_address",
        label: "住所",
        class: "text-left",
        sortable: true
      },
      {
        key: "personIncharge_contactaname",
        label: "担当者姓名",
        class: "text-left",
        sortable: true
      },
      {
        key: "contact_no",
        label: "電話番号",
        sortable: true,
        class: "text-left"
      }
    ];
    if (checkPermisssion("PARTNER", "PARTNER_LIST")) {
      // allowing users to do actions on table if they have Permission
      this.tableHeader.push({
        key: "status",
        label: this.$t("STATUS"),
        sortable: false
      });
      this.tableHeader.push({
        key: "actions",
        label: this.$t("ACTION"),
        sortable: false
      });
    } else {
      this.tableHeader.push({
        key: "status_disable",
        label: this.$t("STATUS"),
        sortable: false
      });
    }
  }
};
</script>

<style scoped>
.btn-add-partner {
  font-size: 17px;
  margin-top: 14px;
  margin-left: 20px;
}

.search-text-box {
  width: 200px;
  margin: 10px 0px;
}
</style>
